import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface ILoadingState {
  pageLoading: boolean;
}

const initialState: ILoadingState = {
  pageLoading: false,
};

export const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    setPageLoading: (state, action: PayloadAction<{ value: boolean }>) => {
      state.pageLoading = action.payload.value;
    },
  },
});

export const { setPageLoading } = loadingSlice.actions;

export const selectPageLoading = (state: RootState) =>
  state.loading.pageLoading;

export default loadingSlice.reducer;
